<div class="feedback-row">
  <ng-container *ngIf="!isRecorded">
    <div class="feedback-row__actions" *ngIf="!isCapturingReason">
      <button type="button" class="feedback-row__button feedback-row__button--primary" (click)="confirmReal()">
        <svg-icon src="assets/icons/check.svg" class="feedback-row__icon" aria-hidden="true"></svg-icon>
        Real
      </button>
      <button type="button" class="feedback-row__button" (click)="startDismissal()">
        <svg-icon src="assets/icons/close-icon.svg" class="feedback-row__icon" aria-hidden="true"></svg-icon>
        Not an issue
      </button>
      <button *ngIf="canAskDeo" type="button" class="feedback-row__button feedback-row__button--ghost" (click)="askDeo()">
        Ask DEO
        <svg-icon src="assets/icons/arrow-right.svg" class="feedback-row__icon" aria-hidden="true"></svg-icon>
      </button>
    </div>

    <div class="feedback-row__reason" *ngIf="isCapturingReason">
      <gains-input [placeholder]="reasonPlaceholder" (valueChange)="onReasonChange($event)"></gains-input>
      <div class="feedback-row__actions">
        <button type="button" class="feedback-row__button feedback-row__button--primary" (click)="dismiss()">Dismiss</button>
      </div>
    </div>
  </ng-container>

  <span class="feedback-row__recorded" *ngIf="isRecorded" [class.feedback-row__recorded--confirmed]="isConfirmed">{{ recordedLabel }}</span>
</div>
